import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["enabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef } from 'react';
import { getAllTabbableIn } from 'ariakit-utils/focus';
import { useWrapElement, useForkRef } from 'ariakit-utils/hooks';
import { createHook, createComponent, createElement } from 'ariakit-utils/system';
import { FocusTrap } from './focus-trap.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
var useFocusTrapRegion = createHook(function (_ref) {
  var _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? false : _ref$enabled,
      props = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);
  props = useWrapElement(props, function (element) {
    var renderFocusTrap = function renderFocusTrap() {
      if (!enabled) return null;
      return /*#__PURE__*/jsx(FocusTrap, {
        onFocus: function onFocus(event) {
          var container = ref.current;
          if (!container) return;
          var tabbables = getAllTabbableIn(container, true);
          var first = tabbables[0];
          var last = tabbables[tabbables.length - 1]; // Fallbacks to the container element

          if (!tabbables.length) {
            container.focus();
            return;
          }

          if (event.relatedTarget === first) {
            last == null ? void 0 : last.focus();
          } else {
            first == null ? void 0 : first.focus();
          }
        }
      });
    };

    return /*#__PURE__*/jsxs(Fragment, {
      children: [renderFocusTrap(), element, renderFocusTrap()]
    });
  }, [enabled]);
  props = _objectSpread(_objectSpread({}, props), {}, {
    ref: useForkRef(ref, props.ref)
  });
  return props;
});
/**
 * A component that renders a focus trap region element.
 * @see https://ariakit.org/components/focus-trap-region
 * @example
 * ```jsx
 * <FocusTrapRegion>
 *  <Button>click me</Button>
 *  <Button>trap focus</Button>
 *  <Button disabled>disabled Button</Button>
 * </FocusTrapRegion>
 * ```
 */

var FocusTrapRegion = createComponent(function (props) {
  var htmlProps = useFocusTrapRegion(props);
  return createElement("div", htmlProps);
});
export { FocusTrapRegion, useFocusTrapRegion };